export const ACTION = {
  PICK_START: 'PICK_START',
  PICK_END: 'PICK_END',
};
